import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import css from "./ClientsListComponent.module.css";
import { clientsActions } from "../../../store/slices/clients-slices";
import { Pagination } from "../../../ui";
import ClientComponent from "../ClientComponent/ClientComponent";
import { paginationActions } from "../../../store/slices/pagination-slices";

const ClientsListComponent = () => {
  const dispatch = useDispatch();

  const { trigger, clientsArray, searchClients, searchQuery, searchField } =
    useSelector((store) => store.clients);
  const { page } = useSelector((store) => store.pagination);

  const dataToRender = useMemo(() => {
    return searchClients?.users?.length > 0 ? searchClients : clientsArray;
  }, [searchClients, clientsArray]);

  const { users, totalPages, total } = dataToRender;

  useEffect(() => {
    dispatch(clientsActions.getAllClients({ page }));
  }, [dispatch, trigger, page]);

  useEffect(() => {
    if (searchQuery !== "") {
      // Reset pagination to page 1 when search changes
      dispatch(paginationActions.changePage(1));

      dispatch(
        clientsActions.getSearchClients({
          page: 1, // Always start from page 1 for new search
          word: searchQuery,
          searchField,
        })
      );
    } else {
      dispatch(clientsActions.getAllClients({ page }));
      dispatch(clientsActions.clearSearch());
    }
  }, [dispatch, trigger, page, searchQuery, searchField]);

  return (
    <section className={css.wrap}>
      <section className={css.header}>
        <div className={css.contact}>Contact</div>
        <div className={css.name}>Name</div>
        <div className={css.address}>Address</div>
        <div className={css.points}>Points</div>
        <div className={css.roles}>Roles</div>
        <div className={css.actions}>Actions</div>
      </section>

      <div className={css.listBlock}>
        {users &&
          users.map((obj) => (
            <ClientComponent key={obj.id} client={obj} page={page} />
          ))}
      </div>

      <div className={css.paginationBlock}>
        <Pagination totalPages={totalPages} totalItems={total} />
      </div>
    </section>
  );
};

export default React.memo(ClientsListComponent);
